import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.5 5.5A1.5 1.5 0 0 0 1 7v7.5A3.5 3.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V9a3.5 3.5 0 0 0-3.5-3.5zm20.5 1a.75.75 0 0 0-1.2-.6l-3.2 2.4a1.5 1.5 0 0 0-.6 1.2V14c0 .472.222.917.6 1.2l3.2 2.4A.75.75 0 0 0 23 17z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandOfficeZoom = { render };
export {
  brandOfficeZoom as default,
  render
};
//# sourceMappingURL=brand-office-zoom.svg.js.map
